var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{attrs:{"value":_vm.value,"type":_vm.type || 'success',"color":_vm.color || 'primary',"transition":"slide-y-reverse-transition"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }